<template>
    <div class="login-container">
        <div class="login-panel">
            <img src="../../assets/images/navitas_logo_white.png" alt="Navitas Safetey Group">
            <text-input
                autocomplete="username email"
                name="email"
                style="margin-bottom: 70px"
                label="E-mail"
                ref="username"
                @keyup.enter.native="actionFederatedEmailStep"
            />

            <text-button label="Sign in using sso" :loading-state="loadingState" @click="actionFederatedEmailStep"/>

            <div class="login-link">
                <a @click="actionReturnToLogin">Return to standard login</a>
            </div>
        </div>
        <login-notice />
    </div>
</template>
<script>
import TextInput from "../components/TextInput";
import TextButton from "../components/TextButton";
import {mapMutations} from "vuex";
import AuthService from "../../new/services/AuthService";
import LoginNotice from "../components/LoginNotice";

export default {

    name: "FederatedEmailLogin",
    components: {LoginNotice, TextButton, TextInput},
    data() {
        return {
            loadingState: false,
        };
    },
    methods: {
        redirectToStandardLogin(email) {
            const query = {federationDisabled: '1'};
            if (email) {
                query.email = email;
            }
            this.$router.push({
                path: this.$enums.RoutePathEnum.LOGIN,
                query,
            });
        },
        actionFederatedEmailStep() {
            this.loadingState = true;

            this.$api.federatedEmailLogin({
                data: {
                    username: this.$refs.username.value,
                },
            }).then(({data}) => {
                if (data && data.usePasswordLogin) {
                    this.redirectToStandardLogin(this.$refs.username.value);
                    return;
                }
                if (data && data.redirectURL) {
                    window.location.href = data.redirectURL;
                }
            }).catch(() => {
                // API errors surfaced via axios / store alerts
            }).finally(() => {
                this.loadingState = false;
            });
        },
        actionReturnToLogin() {
            this.$router.push(this.$enums.RoutePathEnum.LOGIN);
        },
        ...mapMutations('app', {
            setGlobalLoadingState: 'setGlobalLoadingState',
        }),
    },
    mounted() {
        if (AuthService.handleAlreadyAuthenticatedSession()) {
            return;
        }

        if (AuthService.isLogged()) {
            this.$router.push(this.$enums.RoutePathEnum.DASHBOARD);
        }
        this.setGlobalLoadingState(false);
    },
};
</script>
